// extracted by mini-css-extract-plugin
export var container = "_ct-0";
export var infoIcon = "_ct-2";
export var titleRowCol = "_ct-1";